var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03Monitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x30_3-monitoring_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222"
    },
    d: "M21.1,11.9c-0.1,7-7.8,11.7-14,8.2c-0.3-0.2-0.6-0.4-0.9-0.6v-2.6H3.8C1.3,12.6,2.3,6.6,7,3.8 c3.5-2.1,8-1.6,11.1,1.1c-0.6,0.6-1.1,1.1-1.7,1.7C12.3,3.2,5.7,5.2,4.8,10.7C4,16,9.4,20.4,14.4,18.3c2.6-1.1,4.3-3.7,4.3-6.5 c0-0.6-0.9-0.6-1,0c-0.1,2.7-1.9,5.2-4.6,5.9c-2.7,0.7-5.6-0.6-6.9-3.1C5.1,12.1,5.7,9,7.8,7.2c2.3-2,5.6-1.8,7.9,0 c-0.7,0.7-1.3,1.3-2,2c-0.4,0.4,0.2,1.1,0.7,0.7c1.2-1.2,2.4-2.4,3.6-3.6c0.4-0.4,0.8-0.8,1.1-1.1c0.1-0.1,0.1-0.1,0.1-0.2 c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1-0.1-0.2-0.1-0.3c-3-2.9-7.4-3.8-11.2-2.3C4.5,3.7,2,6.8,1.5,10.4 c-0.4,2.6,0.3,5.1,1.6,7.1v2.5h2.3c2.8,2.2,6.6,3,10.2,1.5c3.9-1.6,6.4-5.4,6.4-9.6C22.1,11.2,21.1,11.2,21.1,11.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "5.3,18.6 5.3,19 4.4,19 4.1,19 4.1,18.7 4.1,17.8 4.5,17.8 5.3,17.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.1955,
    y1: 11.8486,
    x2: 14.3056,
    y2: 11.8486
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 9.3,
    style: {
      fill: "url(#SVGID_1_)"
    },
    width: 5.1,
    height: 5.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Monitoring);
export default __webpack_public_path__ + "static/media/03-monitoring.bfd5cbc56c43b76134b3066ecb0c7f75.svg";
export { ForwardRef as ReactComponent };